module.exports = __webpack_public_path__ + "img/lubennikova.d2c1853f.jpg";